function cov_283qe922v7() {
  var path = "/app/src/components/popup-learn-more-close/popup-learn-more-close.tsx";
  var hash = "73043270883b612d5c3030e7300184950b6c4807";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/popup-learn-more-close/popup-learn-more-close.tsx",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 35
        },
        end: {
          line: 18,
          column: 1
        }
      },
      "1": {
        start: {
          line: 11,
          column: 2
        },
        end: {
          line: 17,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 7,
            column: 35
          },
          end: {
            line: 7,
            column: 36
          }
        },
        loc: {
          start: {
            line: 10,
            column: 32
          },
          end: {
            line: 18,
            column: 1
          }
        },
        line: 10
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {
      "0": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "73043270883b612d5c3030e7300184950b6c4807"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_283qe922v7 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_283qe922v7();
import cn from 'classnames';
import React from 'react';
import styles from './styles.css';
cov_283qe922v7().s[0]++;
export var PopupLearnMoreClose = function PopupLearnMoreClose(_ref) {
  var onClose = _ref.onClose,
    className = _ref.className;
  cov_283qe922v7().f[0]++;
  cov_283qe922v7().s[1]++;
  return /*#__PURE__*/React.createElement("div", {
    onClick: onClose,
    className: cn(styles.close, className),
    "data-test": "widget-close"
  });
};